import { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Box, Grid, Typography } from "../../../../components";
import { MonitorFaturamentoService } from "../../../../services";
import { formatPrice, responseErros } from "../../../../utils";
import MonitorFatCard from "./monitor-fat-card.view";

const monitorFaturamentoService = new MonitorFaturamentoService();

const COR_PRODUTOS = "#1976d2";
const COR_SERVICOS = "#00897b";
const COR_PRODUTOS_SERVICOS = "#f57c00";
const defaultData = {
  produtos: { valor: 0, percentual: 0 },
  servicos: { valor: 0, percentual: 0 },
};

function LegendaItem({ cor, label, valor, pct }) {
  return (
    <Box display="flex" alignItems="center" gap={2} mb={0.75}>
      <Box display="flex" alignItems="center" gap={1}>
        <Box
          sx={{
            width: 10,
            height: 10,
            borderRadius: "50%",
            backgroundColor: cor,
          }}
        />
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {label}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" gap={1}>
        <Typography variant="body2" sx={{ fontWeight: 700, color: "#1e293b" }}>
          {formatPrice(valor)}
        </Typography>
        <Typography
          variant="caption"
          sx={{ color: "text.disabled", minWidth: 36, textAlign: "right" }}
        >
          {(pct || 0).toFixed(1)}%
        </Typography>
      </Box>
    </Box>
  );
}

function MonitorFatProdutosServicos({ filtrosBody }) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(defaultData);

  const produtos = data.produtos || { valor: 0, percentual: 0 };
  const servicos = data.servicos || { valor: 0, percentual: 0 };
  const produtosServico = data.produtosServicos || { valor: 0, percentual: 0 };
  const total =
    (produtos.valor || 0) +
    (servicos.valor || 0) +
    (produtosServico.valor || 0);

  useEffect(() => {
    buscarProdutosServicos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtrosBody]);

  async function buscarProdutosServicos() {
    setLoading(true);
    const result = await monitorFaturamentoService.faturamentoProdutosServicos(
      filtrosBody,
    );
    if (!result.isAxiosError) {
      setData(result.data || defaultData);
    } else {
      responseErros(result);
    }
    setLoading(false);
  }

  const chartOptions = {
    chart: {
      type: "pie",
      backgroundColor: "transparent",
      margin: [4, 4, 4, 4],
    },
    title: { text: "" },
    credits: { enabled: false },
    legend: { enabled: false },
    tooltip: {
      useHTML: true,
      backgroundColor: "#fff",
      borderWidth: 0,
      borderRadius: 4,
      pointFormatter: function () {
        return `<b>${this.name}</b>: ${formatPrice(
          this.y,
        )} (${this.percentage.toFixed(1)}%)`;
      },
    },
    plotOptions: {
      pie: {
        innerSize: "72%",
        size: "92%",
        center: ["50%", "50%"],
        borderWidth: 2,
        borderColor: "#fff",
        dataLabels: { enabled: false },
      },
    },
    series: [
      {
        name: "Total",
        animation: false,
        data: [
          { name: "Produtos", y: produtos.valor, color: COR_PRODUTOS },
          { name: "Serviços", y: servicos.valor, color: COR_SERVICOS },
          {
            name: "Produtos e Serviços",
            y: produtosServico.valor,
            color: COR_PRODUTOS_SERVICOS,
          },
        ],
      },
    ],
  };

  return (
    <MonitorFatCard
      titulo="Faturamento de Produtos x Serviços"
      icone="ph-chart-pie-slice"
      loading={loading}
    >
      <Grid
        container
        spacing={2}
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        className="mt-3"
      >
        <Grid item xs={12} sm={5}>
          <Box sx={{ position: "relative" }}>
            <HighchartsReact highcharts={Highcharts} options={chartOptions} />
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                textAlign: "center",
                pointerEvents: "none",
              }}
            >
              <Typography
                sx={{
                  fontWeight: 800,
                  fontSize: 13,
                  color: "#1e293b",
                  lineHeight: 1.1,
                }}
              >
                {formatPrice(total)}
              </Typography>

              <Typography variant="caption" sx={{ color: "text.secondary" }}>
                Total
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} sm={5}>
          <Box>
            <LegendaItem
              cor={COR_PRODUTOS}
              label="Produtos"
              valor={produtos.valor}
              pct={produtos.percentual}
            />

            <LegendaItem
              cor={COR_SERVICOS}
              label="Serviços"
              valor={servicos.valor}
              pct={servicos.percentual}
            />

            <LegendaItem
              cor={COR_PRODUTOS_SERVICOS}
              label="Produtos da OS"
              valor={produtosServico.valor}
              pct={produtosServico.percentual}
            />
          </Box>
        </Grid>
      </Grid>
    </MonitorFatCard>
  );
}

export default MonitorFatProdutosServicos;
